module.exports = __webpack_public_path__ + "media/icons/green-mail-7712f9eb.svg";